module.exports = __webpack_public_path__ + "static/media/1274_CareTeam2_photo.eca1c5d7.png";